import React from "react";
import { Link } from "react-router-dom";

function UserForm() {
  return (
    <>
      <div id="print-section">
        <div className="staticPage payautho">
          <div className="container">
            <div className="autopayRowHead">
              <h1 style={{ whiteSpace: "nowrap" }}>
                AUTHORIZATION FOR DIRECT PAYMENTS VIA ACH
              </h1>
            </div>
            <div className="sectionRowPay">
              <div className="paydetail">Account Number: xxx-xxx-</div>
              <p>
                {" "}
                Direct Payment via ACH is the transfer of funds from a consumer
                account for the purpose of making a payment.{" "}
              </p>
              <p>
                {" "}
                I, authorize Abound to electronically debit my account
                referenced above for recurring monthly payments of $1.99,
                effective on for the Gaana+ service. I agree that these
                transactions comply with all applicable law.{" "}
              </p>
              <p>
                I understand that this authorization becomes effective today, ,
                and will remain in full force and effect until I cancel my
                Gaana+ subscription on the Abound platform by going to{" "}
                <Link to="/accounts" target="_blank">
                  <span className="link_underLine">Manage Subscriptions</span>
                </Link>
                . Such cancellation will be my notice to Abound that I wish to
                revoke this authorization. I understand that Abound requires at
                least 10 days prior notice in order to cancel this
                authorization.{" "}
              </p>
              <p>
                Please print this authorization and retain a copy for your
                records
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserForm;
